import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";

export const AdminRunrocketTrainingDataEdit = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();
  const { set_id } = useParams(); // Get template_id & set_id from URL

  const [setData, setSetData] = useState(null);
  const [reps, setReps] = useState("");
  const [distance, setDistance] = useState("");
  const [rest, setRest] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchSetData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${API_URL.GET_RUNROCKET_TRAINING_TEMPLATE_SET}${set_id}`,
          {
            headers: { Authorization: `Bearer ${staff.token}` },
          },
        );
        const data = await response.json();

        if (!response.ok)
          throw new Error(data.message || "Failed to load set data");

        setSetData(data);
        setReps(data.reps);
        setDistance(data.distance);
        setRest(data.rest);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSetData();
  }, [set_id]);

  const saveSetData = async () => {
    setSuccessMessage("");
    try {
      const response = await fetch(
        `${API_URL.EDIT_RUNROCKET_TRAINING_TEMPLATE_SET}${set_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify({ reps, distance, rest }),
        },
      );

      const data = await response.json();
      if (!response.ok)
        throw new Error(data.message || "Failed to update set data");

      setSuccessMessage("Set data updated successfully!");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="md:flex md:h-screen">
      <StaffSideMenu />
      <div className="md:flex-1 p-5 bg-bgBase flex flex-col relative">
        <button
          onClick={() => navigate(-1)}
          className="text-slate100 font-inter font-normal text-sm leading-tight flex items-center gap-2 hover:underline max-md:pl-12"
        >
          <GoArrowLeft color="#666666" /> Back To Library
        </button>

        <div className="w-full max-w-screen-xl lg:px-16 py-6 space-y-6">
          <div className="bg-white border border-tblBorder p-5 md:p-8 rounded-14">
            <h2 className="font-inter font-medium text-dark text-2xl !leading-none mb-6">
              Edit Training Data
            </h2>

            {isLoading ? (
              <div className="bg-white border border-tblBorder rounded-md w-fit mx-auto py-2 px-5">
                <p className="text-dark text-sm font-inter font-normal text-center">
                  Loading set data...
                </p>
              </div>
            ) : error ? (
              <div className="bg-red-300 border border-red-500 rounded-md w-fit mx-auto py-2 px-5">
                <p className="text-red-500 text-center">{error}</p>
              </div>
            ) : (
              <>
                {successMessage && (
                  <div className="bg-green-300 border border-green-700 rounded-md w-fit mx-auto py-2 px-5">
                    <p className=" text-green-700 text-center rounded">
                      {successMessage}
                    </p>
                  </div>
                )}
                <div className="mb-5">
                  <label className="block font-inter text-slate100 text-sm font-medium">Reps</label>
                  <input
                    type="text"
                    className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                    value={reps}
                    onChange={(e) => setReps(e.target.value)}
                  />
                </div>
                <div className="mb-5">
                  <label className="block font-inter text-slate100 text-sm font-medium">Distance (m)</label>
                  <input
                    type="text"
                    className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                    value={distance}
                    onChange={(e) => setDistance(e.target.value)}
                  />
                </div>
                <div className="mb-5">
                  <label className="block font-inter text-slate100 text-sm font-medium">Rest</label>
                  <textarea
                    className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                    value={rest}
                    onChange={(e) => setRest(e.target.value)}
                  />
                </div>

                {/* <div className="flex justify-center"> */}
                <button
                  onClick={saveSetData}
                  className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                >
                  Save
                </button>
                {/* </div> */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
